/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface S3BucketDeletionInfo { 
    name: string;
    region_id: string;
    /**
     * bucket creation timestamp
     */
    create_time: Date;
    /**
     * Bucket deletion timestamp
     */
    delete_time?: Date;
    /**
     * Bucket deleted or not
     */
    deleted?: boolean;
    /**
     * Expiration set or not
     */
    expiration_set?: boolean;
    /**
     * timestamp when the bucket objects will be deleted
     */
    expiration_time?: Date;
    isEmpty?: boolean;
    deleteError?: string;
}

